export default function deleteCartIds() {
  localStorage.removeItem("cart_ids");
}
